import Table from 'react-bootstrap/Table';
import React, { useRef, useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Button from 'react-bootstrap/Button';
import mapboxgl from '!mapbox-gl';
import CannonSettings from '../modals/CannonSettings';
import 'mapbox-gl/dist/mapbox-gl.css';
import { HiOutlineInformationCircle } from 'react-icons/hi';
import styles from "./fullWidth.module.css";
import Moment from 'react-moment';

mapboxgl.accessToken = 'pk.eyJ1IjoiamFja3k0NTY2IiwiYSI6ImNrdm54ODFqcGUzOWsycXE2Y2YxZXR3MDIifQ.pJwfydUY9qaUrkCb2NKxyA';

export default function FullWidthCellRenderer(props) {
  const [device] = useState(props.node.data);
  const [tankCounter, settankCounter] = useState(0.0);
  const mapContainer = useRef(null);
  const map = useRef(null);

  useEffect(() => {
    settankCounter(device.tankCounter);
  }, []);

  useEffect(() => {
    if (map.current) return; // initialize map only once
    const location = new mapboxgl.LngLat(parseFloat(device.longitude), parseFloat(device.latitude));
    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/mapbox/satellite-streets-v11',
      center: location,
      zoom: 13,
    });

    map.current.addControl(new mapboxgl.NavigationControl(), 'top-left');

    new mapboxgl.Marker()
      .setLngLat(location)
      .addTo(map.current);
  }, [device]);

  const resetTank = () => {
    settankCounter(0);
    const headers = { 'X-API-KEY': '7EAFDEADBEEF' };
    fetch('/api/v1/resetTank/' + device.deviceID, { headers })
      .then(response => {
        toast.success(response, { position: toast.POSITION.BOTTOM_RIGHT })
      })
  }

  return (
    <div className={styles.fullwidthpanel}>
      <Table borderless size="sm" className={styles.datatable}>
        <tbody>
          <tr>
            <th >ID:</th>
            <td>{device.deviceID}</td>
          </tr>
          <tr>
            <th>Device type:</th>
            <td>{device.firmwareV}</td>
          </tr>
          <tr>
            <th >Reading ID:</th>
            <td>{device.readingID} </td>
          </tr>
          <tr>
            <th >Last Heard:</th>
            <td>{<Moment date={device.recordDate} format="DD-MMM-YY, hh:mm a" />} </td>
          </tr>
          <tr>
            <th >Battery Voltage:</th>
            <td>{device.batteryV}V</td>
          </tr>
          <tr>
            <th >Temperature:</th>
            <td>{parseFloat(device.tempC).toFixed(2)}C ({(parseFloat(device.tempC) * 9 / 5 + 32).toFixed(2)} F)</td>
          </tr>
          <tr>
            <th >Life Counter:</th>
            <td>{device.lifeCounter}</td>
          </tr>
          <tr>
            <th >Misfire Counter:</th>
            <td>{device.misfires} </td>
          </tr>
          <tr>
            <th >Tank Counter: <HiOutlineInformationCircle title="20 lbs bottle last 15,000" /></th>
            <td>{tankCounter} <Button variant="warning" size="sm" onClick={resetTank}>Reset</Button ></td>
          </tr>
          <tr>
            <th >
              
              <CannonSettings prop={device} />
            </th>
          </tr>
        </tbody>
      </Table>
      <div ref={mapContainer} className={styles.mapminicontainer}>
        <div className={styles.mapminisidebar}>
          <div>Longitude: {parseFloat(device.latitude).toFixed(4)}</div>
          <div>Latitude: {parseFloat(device.longitude).toFixed(4)}</div>
          <div>Accuracy: {device.accuracyM}</div>
        </div>
      </div>
    </div >
  );
}